import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=838e9678&scoped=true&lang=pug"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e9678",
  null
  
)

export default component.exports